import React, { useEffect, useState } from "react";
import { Box, Typography, Button, TextField, InputAdornment } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchTasks } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function TaskListPage() {
  const { businessDomainId, jobId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        setRows(await fetchTasks(jobId));
      } catch (e) {
        notify.apiError(e);
      } finally {
        setLoading(false);
      }
    })();
  }, [jobId]);

  const filteredRows = searchText
    ? rows.filter((r) => r.taskOrder?.toLowerCase().includes(searchText.toLowerCase()))
    : rows;

  const columns = [
    { field: "taskOrder", headerName: t("task.order"), width: 80 },
    { field: "taskName", headerName: t("task.name"), flex: 1, minWidth: 200 },
    { field: "taskDescription", headerName: t("task.description"), flex: 1, minWidth: 200 },
    { field: "functionName", headerName: t("task.function"), flex: 1, minWidth: 150 },
  ];

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">{t("task.list.title")}</Typography>
        <TextField size="small" placeholder={t("common.search")} value={searchText} onChange={(e) => setSearchText(e.target.value)} InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }} />
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate(`/design/${businessDomainId}/jobs/${jobId}/tasks/create`)}
        >
          {t("common.add")}
        </Button>
      </Box>
      <DataGrid
        rows={filteredRows}
        columns={columns}
        getRowId={(r) => r.taskId}
        loading={loading}
        autoHeight
        pageSizeOptions={[10, 25, 50]}
        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        onRowClick={(params) =>
          navigate(`/design/${businessDomainId}/jobs/${jobId}/tasks/${params.row.taskId}`)
        }
        sx={{ cursor: "pointer" }}
      />
    </Box>
  );
}
